<script>
    /**
     * Single month view calendar for user page
     * @requires ./BaseCalendar.vue
     * @displayName SingleBookingCalendar
     */
    import BaseCalendar from './BaseCalendar.vue'

    export default {
        name: 'SingleBookingCalendar',
        extends: BaseCalendar,
        props: {
            visibility: {
                type: String,
                required: false
            }
        },
        computed: {
            monthsClass: (self) => (indx) => {
                if (self.isHiddenMonths(indx))
                    return { 'single-booking-view-hidden-months': true }
                if (self.isCurrentMonths(indx))
                    return { 'single-booking-view-curr-months': true }
                if (self.isPrevHiddenMonths(indx)) {
                    let classes = { 'single-booking-view-prev-hidden-months': true }
                    if (self.visibility) classes[self.visibility] = true
                    return classes
                }
                if (self.isNextHiddenMonths(indx)) {
                    let classes = { 'single-booking-view-next-hidden-months': true }
                    if (self.visibility) classes[self.visibility] = true
                    return classes
                }
            }
        },
        methods: {
            isCurrentMonths(indx) {
                return indx === this.viewIndx
            },
            isNextHiddenMonths(indx) {
                let currentLen = this.calendarView.length

                if (indx === this.viewIndx + 1) return true
                if (this.viewIndx === currentLen - 1 && indx === 0) return true

                return false
            },
            isPrevHiddenMonths(indx) {
                let currentLen = this.calendarView.length

                if (indx === this.viewIndx - 1) return true
                if (indx === currentLen - 1 && this.viewIndx === 0) return true

                return false
            },
            isHiddenMonths(indx) {
                if (
                    this.isNextHiddenMonths(indx) ||
                    this.isPrevHiddenMonths(indx) ||
                    this.isCurrentMonths(indx)
                )
                    return false

                return true
            }
        }
    }
</script>
<style lang="scss" scoped>
    $smallMobile: 350px;
    $medSizeMobile: 400px;
    @media screen and (max-width: $smallMobile) {
        .single-booking-view-prev-hidden-months.month {
            margin-left: -272px !important;
        }
    }
    @media screen and (max-width: $medSizeMobile) and (min-width: $smallMobile) {
        .single-booking-view-prev-hidden-months.month {
            margin-left: -317px !important;
        }
    }
    .single-booking-view-hidden-months {
        display: none !important;
    }
    .single-booking-view-prev-hidden-months {
        order: 1;
    }
    .single-booking-view-curr-months {
        order: 2;
    }
    .single-booking-view-next-hidden-months {
        order: 3;
    }
    .single-booking-view-prev-hidden-months.month {
        margin-left: -333px;

        .month-label {
            visibility: hidden !important;
        }
        .month-view {
            background-image: linear-gradient(360deg, #262626, #26262680, #26262600);

            .header {
                overflow: hidden !important;
            }
            .dates {
                overflow: hidden !important;
            }
        }
    }
    .single-booking-view-next-hidden-months.month {
        .month-label {
            visibility: hidden !important;
        }
        .month-view {
            background-image: linear-gradient(360deg, #262626, #26262680, #26262600);

            .header {
                overflow: hidden !important;
            }
            .dates {
                overflow: hidden !important;
            }
        }
    }
</style>
